const adjectives = [
  'abandoned',
  'aching',
  'advanced',
  'ajar',
  'ample',
  'another',
  'artistic',
  'authorized',
  'back',
  'best',
  'blank',
  'bold',
  'brief',
  'candid',
  'charming',
  'clear',
  'cold',
  'complicated',
  'cooked',
  'crazy',
  'crushing',
  'dear',
  'definite',
  'dependable',
  'diligent',
  'downright',
  'drab',
  'earnest',
  'elderly',
  'enchanted',
  'essential',
  'excellent',
  'extraneous',
  'fixed',
  'flowery',
  'formal',
  'fresh',
  'frosty',
  'gargantuan',
  'giving',
  'glossy',
  'granular',
  'gripping',
  'grumpy',
  'healthy',
  'husky',
  'impassioned',
  'impressionable',
  'indelible',
  'internal',
  'jaunty',
  'juicy',
  'kindly',
  'large',
  'left',
  'linear',
  'long',
  'loyal',
  'majestic',
  'memorable',
  'minty',
  'monthly',
  'mundane',
  'nautical',
  'new',
  'notable',
  'only',
  'ordinary',
  'overcooked',
  'passionate',
  'pertinent',
  'plaintive',
  'political',
  'potable',
  'prickly',
  'proper',
  'puzzled',
  'reflecting',
  'respectful',
  'roasted',
  'rundown',
  'sandy',
  'scholarly',
  'shadowy',
  'silver',
  'slight',
  'smug',
  'somber',
  'sparkling',
  'spotless',
  'standard',
  'stupendous',
  'sunny',
  'tart',
  'this',
  'timely',
  'trustworthy',
  'uncommon',
  'unnatural',
  'untimely',
  'upbeat',
  'vacant',
  'virtual',
  'warmhearted',
  'weary',
  'whispered',
  'wilted',
  'wooden',
  'worthwhile',
];

const nouns = [
  'abnormality',
  'acceptance',
  'account',
  'acknowledgment',
  'activist',
  'address',
  'adrenalin',
  'advertising',
  'agent',
  'air',
  'airplane',
  'alder',
  'allergist',
  'almond',
  'alto',
  'ambulance',
  'analogue',
  'android',
  'animal',
  'ant',
  'anticodon',
  'anywhere',
  'appellation',
  'appointment',
  'aquifer',
  'archives',
  'armchair',
  'arrival',
  'artist',
  'asphalt',
  'assistance',
  'astrology',
  'attachment',
  'attitude',
  'authenticity',
  'availability',
  'baboon',
  'backpack',
  'baggage',
  'balaclava',
  'bamboo',
  'bank',
  'barbecue',
  'barometer',
  'baseline',
  'bassoon',
  'battery',
  'bean',
  'beauty',
  'beggar',
  'belfry',
  'beneficiary',
  'bibliography',
  'bill',
  'birch',
  'bite',
  'blame',
  'blossom',
  'boatload',
  'bondsman',
  'bookend',
  'bottom',
  'boutique',
  'boy',
  'bran',
  'breakfast',
  'bride',
  'broccoli',
  'brook',
  'brushfire',
  'buffalo',
  'bull',
  'burden',
  'burst',
  'butter',
  'cabbage',
  'caffeine',
  'caliber',
  'campaign',
  'candle',
  'canvas',
  'cappelletti',
  'carbon',
  'carnation',
  'carrier',
  'carving',
  'casserole',
  'catalyst',
  'cattle',
  'celebration',
  'cenotaph',
  'ceramics',
  'chair',
  'champagne',
  'chaplain',
  'charm',
  'chauffeur',
  'cheese',
  'chess',
  'childhood',
  'chop',
  'chronicle',
  'cigarette',
  'circumstance',
  'claim',
  'class',
  'clay',
  'click',
  'cloakroom',
  'cloth',
  'cluster',
  'cobbler',
  'codling',
  'coincidence',
  'collard',
  'colon',
  'columnist',
  'comic',
  'commitment',
  'community',
  'competitor',
  'component',
  'compulsion',
  'conclusion',
  'conference',
  'congregation',
  'consumer',
  'contingency',
  'control',
  'conviction',
  'cope',
  'cork',
  'corporatism',
  'costume',
  'councilperson',
  'countess',
  'courtroom',
  'crab',
  'crawdad',
  'creche',
  'crewman',
  'croissant',
  'crude',
  'crystallography',
  'culture',
  'curiosity',
  'curtailment',
  'cutlet',
  'cynic',
  'daily',
  'date',
  'dealing',
  'decency',
  'decoration',
  'deliberation',
  'density',
  'depot',
  'descent',
  'destination',
  'detention',
  'device',
  'dialogue',
  'dig',
  'dime',
  'diploma',
  'disagreement',
  'discount',
  'disengagement',
  'divider',
  'document',
  'dollop',
  'door',
  'doubt',
  'downtown',
  'drainage',
  'dreamer',
  'driveway',
  'duck',
  'dumbwaiter',
  'duster',
  'earrings',
  'ecclesia',
  'ecumenist',
  'eel',
  'egghead',
  'electrocardiogram',
  'elimination',
  'emission',
  'emu',
  'endoderm',
  'engineering',
  'entrance',
  'ephemera',
  'equality',
  'escalator',
  'estrogen',
  'evaluator',
  'evidence',
  'example',
  'excuse',
  'existence',
  'experiment',
  'exposure',
  'eyeball',
  'eyrie',
  'faculty',
  'farm',
  'fax',
  'feedback',
  'fender',
  'fiber',
  'fiesta',
  'fillet',
  'finer',
  'firewall',
  'fit',
  'flash',
  'flick',
  'floozie',
  'fly',
  'folklore',
  'football',
  'force',
  'forever',
  'formula',
  'fountain',
  'frenzy',
  'fright',
  'fruit',
  'fund',
  'gaffe',
  'garbage',
  'gastropod',
  'gazelle',
  'gene',
  'geography',
  'gift',
  'girlfriend',
  'gliding',
  'godfather',
  'good',
  'gosling',
  'graduate',
  'granddaughter',
  'grant',
  'gravel',
  'green',
  'gripper',
  'guacamole',
  'guideline',
  'hacienda',
  'halibut',
  'hand',
  'handrail',
  'hardcover',
  'harmony',
  'hat',
  'hawk',
  'headquarters',
  'hearth',
  'hedgehog',
  'helmet',
  'hermit',
  'hierarchy',
  'hip',
  'hobby',
  'hometown',
  'hood',
  'hornet',
  'hospitality',
  'house',
  'hub',
  'humor',
  'hurry',
  'hydrocarb',
  'hype',
  'icicle',
  'idiom',
  'imagination',
  'implement',
  'improvement',
  'incense',
  'increase',
  'industrialization',
  'infix',
  'ingrate',
  'injunction',
  'input',
  'inspection',
  'instructor',
  'integration',
  'interconnection',
  'interval',
  'invention',
  'invite',
  'island',
  'jackfruit',
  'jazz',
  'jewellery',
  'joke',
  'jug',
  'junk',
  'kayak',
  'kettledrum',
  'king',
  'knot',
  'laborer',
  'ladybug',
  'landing',
  'larch',
  'latex',
  'lawmaker',
  'leading',
  'lecture',
  'legislator',
  'length',
  'lever',
  'licorice',
  'light',
  'lime',
  'lining',
  'liquidity',
  'littleneck',
  'loan',
  'locomotive',
  'loincloth',
  'lord',
  'lox',
  'lung',
  'lyre',
  'macrame',
  'magnitude',
  'mainstream',
  'making',
  'man',
  'mangrove',
  'manservant',
  'mapping',
  'marines',
  'marmalade',
  'mass',
  'material',
  'maybe',
  'measles',
  'medal',
  'melon',
  'menorah',
  'mesenchyme',
  'meteorology',
  'micronutrient',
  'might',
  'mill',
  'mincemeat',
  'mining',
  'miracle',
  'mission',
  'moai',
  'model',
  'molecule',
  'monkey',
  'moon',
  'morsel',
  'mother',
  'mountain',
  'mower',
  'muscle',
  'mustache',
  'name',
  'nature',
  'neglect',
  'nephew',
  'networking',
  'nexus',
  'nightgown',
  'node',
  'norm',
  'nothing',
  'nudge',
  'nurture',
  'oatmeal',
  'observation',
  'octagon',
  'offense',
  'oleo',
  'opening',
  'opportunity',
  'orator',
  'organisation',
  'osmosis',
  'outfit',
  'outrun',
  'overflight',
  'owner',
  'package',
  'pamphlet',
  'pantologist',
  'paperwork',
  'parking',
  'particle',
  'passing',
  'pastry',
  'pathway',
  'patrolling',
  'pay',
  'peanut',
  'pegboard',
  'penicillin',
  'percent',
  'peripheral',
  'personnel',
  'pharmacopoeia',
  'phosphate',
  'physics',
  'pickup',
  'piglet',
  'ping',
  'placebo',
  'plant',
  'platinum',
  'pleat',
  'plowman',
  'politician',
  'pomelo',
  'popsicle',
  'porter',
  'postage',
  'pouch',
  'praise',
  'prefix',
  'pressure',
  'pricing',
  'print',
  'prize',
  'processor',
  'professor',
  'project',
  'propane',
  'prosecutor',
  'providence',
  'pseudoscience',
  'publisher',
  'pump',
  'pupil',
  'push',
  'quantity',
  'questionnaire',
  'quota',
  'radar',
  'rail',
  'rainy',
  'rancher',
  'ratepayer',
  'razor',
  'realization',
  'recapitulation',
  'reclamation',
  'recreation',
  'reference',
  'regard',
  'release',
  'remote',
  'replacement',
  'reprocessing',
  'resemblance',
  'resolution',
  'restoration',
  'retirement',
  'reveal',
  'revival',
  'rib',
  'rim',
  'ritual',
  'robot',
  'romaine',
  'roster',
  'rowing',
  'ruin',
  'rush',
  'safeguard',
  'salad',
  'salute',
  'sandbar',
  'satire',
  'savior',
  'scam',
  'scheduling',
  'scientist',
  'scow',
  'sea',
  'seat',
  'sector',
  'self',
  'semiconductor',
  'sensor',
  'series',
  'set',
  'shadow',
  'share',
  'sheet',
  'shingle',
  'shopper',
  'shout',
  'sick',
  'sigh',
  'silence',
  'simple',
  'sip',
  'skean',
  'skunk',
  'slaw',
  'slider',
  'smelting',
  'snail',
  'snorer',
  'snug',
  'soda',
  'solicitor',
  'someplace',
  'soot',
  'sound',
  'sow',
  'sparrow',
  'special',
  'speech',
  'spider',
  'spit',
  'spool',
  'spray',
  'spume',
  'stab',
  'stair',
  'stand',
  'starter',
  'statute',
  'stencil',
  'sticker',
  'stock',
  'stopwatch',
  'strait',
  'streetcar',
  'structure',
  'stump',
  'subcontractor',
  'subset',
  'succotash',
  'sultan',
  'sundial',
  'supermarket',
  'suppression',
  'surround',
  'sustainment',
  'sweatsuit',
  'switching',
  'syndicate',
  'tabby',
  'tactile',
  'talent',
  'tank',
  'tart',
  'taxicab',
  'technician',
  'teletype',
  'temporary',
  'tension',
  'terminology',
  'testimony',
  'theism',
  'thickness',
  'thought',
  'thump',
  'tide',
  'timeline',
  'tire',
  'toenail',
  'tomatillo',
  'tonight',
  'topsail',
  'tote',
  'town',
  'tractor',
  'trailer',
  'transfer',
  'transportation',
  'treasury',
  'triad',
  'trinket',
  'trousers',
  'try',
  'tumbler',
  'turmeric',
  'tutu',
  'twitter',
  'uncle',
  'undertaker',
  'unique',
  'upward',
  'utilisation',
  'validity',
  'variability',
  'vector',
  'velocity',
  'venue',
  'verve',
  'vibration',
  'villa',
  'visitor',
  'void',
  'voting',
  'waiter',
  'wallaby',
  'warfare',
  'wasabi',
  'watch',
  'waterspout',
  'weasel',
  'weedkiller',
  'west',
  'whelp',
  'wholesaler',
  'wilderness',
  'windscreen',
  'wiretap',
  'witness',
  'woodshed',
  'workhorse',
  'worth',
  'wrestler',
  'yak',
  'yesterday',
  'youth',
  'zinc',
];

const randomInt = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const createName = (prefix: string) => {
  const adjective = adjectives[randomInt(0, adjectives.length - 1)];
  const noun = nouns[randomInt(0, nouns.length - 1)];
  const number = randomInt(1, 100);
  return `${prefix}-${adjective}-${noun}-${number}`;
};
